import _ from 'lodash';

import Broadcast from "./Broadcast";

export const Service = class {

	constructor(properties) {

		const mixins = properties.Libraries || [];

		delete properties.Libraries;

		let init = function() {};

		if (!this.Actions) this.Actions = {};

		if (!this.Events) this.Events = {};

		if (properties.init) init = properties.init;

		if (!properties.Name) throw "Service must have own Name property! " + this.Name;

		Object.assign(this, properties);

		for (let i = 0; mixins[i]; i++) {

			if (!mixins[i].Name) throw "Library must have own Name property! " + this.Name;

			Object.assign(this, _.omit(mixins[i], ['init', 'Name', 'Actions', 'Routes', 'Events']));

		}

		this.init = () => {

			this.activateActions(properties.Actions, this);

			for (let i=0; mixins[i]; i++) {

				this.activateActions(mixins[i].Actions, mixins[i]);

			}

			Broadcast.call('Service Actions Activated', [this, mixins]);

			this.activateEvents(properties.Events, this);

			for (let i=0; mixins[i]; i++) {

				this.activateEvents(mixins[i].Events, mixins[i]);

			}

			Broadcast.call('Service Events Activated', [this, mixins]);

			init.apply(this, []);

			for (let i=0; mixins[i]; i++) {

				if (mixins[i].init) mixins[i].init.apply(this, []);

			}

			Broadcast.call('Service Init', [this, mixins]);

		};

	}

	activateActions(actions, context) {

		Broadcast.on('Server Data Received', (data) => {

			_.each(context.Actions, (fn, key) => {

				if (data && key in data) fn.apply(context, [data[key], data]);

			});

			if (context.Actions && context.Actions['*']) {

				context.Actions['*'].apply(context, [data]);

			}

		}, context);

	}

	activateEvents(events, context) {

		_.each(events, (fn, event_name) => {

			Broadcast.on(event_name, fn, context);

		});

	}

};
